import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { message, Spin } from 'antd';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();
  const [hasShownMessage, setHasShownMessage] = useState(false);

  useEffect(() => {
    // Логируем статус авторизации для отладки
    if (!isLoading) {
      
    }
  }, [isAuthenticated, user, location.pathname, isLoading]);

  useEffect(() => {
    // Показываем сообщение об ошибке только один раз, когда авторизация завершена и пользователь не авторизован
    if (!isLoading && !isAuthenticated && !hasShownMessage) {
      message.error('Для доступа к этой странице необходимо авторизоваться');
      setHasShownMessage(true);
    } else if (isAuthenticated) {
      // Сбрасываем флаг при успешной авторизации
      setHasShownMessage(false);
    }
  }, [isLoading, isAuthenticated, hasShownMessage]);

  // Показываем индикатор загрузки, пока проверяем авторизацию
  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" spinning={true} tip="Проверка авторизации...">
          <div style={{ width: 200, height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {/* Пустой див для режима nest */}
          </div>
        </Spin>
      </div>
    );
  }

  // После завершения проверки авторизации, если пользователь не авторизован - редиректим
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
